import { useEffect, useMemo, useState } from 'react';

export default function useHover(): [
  boolean,
  { onMouseEnter: () => void; onMouseLeave: () => void }
] {
  const [isHover, setIsHover] = useState(false);

  const hoverEventHandlers = useMemo(
    () => ({
      onMouseEnter() {
        setIsHover(true);
      },
      onMouseLeave() {
        setIsHover(false);
      },
    }),
    []
  );

  useEffect(() => {});

  return [isHover, hoverEventHandlers];
}
